<template>
  <div class="ide-page">
    <!-- Header -->
    <div style="display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:20px; flex-wrap:wrap; gap:12px;">
      <div>
        <h2 style="font-size:18px; font-weight:800; color:var(--text-heading); letter-spacing:-0.3px; margin-bottom:4px;">Sucursales</h2>
        <p style="font-size:12px; color:var(--text-faint);">Gestiona las sucursales físicas, inventario, pedidos y caja</p>
      </div>
      <button class="btn-add" @click="abrirForm(null)">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Nueva sucursal
      </button>
    </div>

    <!-- Stats row -->
    <div style="display:grid; grid-template-columns:repeat(3,1fr); gap:10px; margin-bottom:20px; max-width:480px;">
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:22px; font-weight:900; color:var(--text-heading); line-height:1;">{{ sucursales.length }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Sucursales</div>
      </div>
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:22px; font-weight:900; color:#22c55e; line-height:1;">{{ activas }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Activas</div>
      </div>
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:22px; font-weight:900; color:#0ea5e9; line-height:1;">{{ cajaAbierta }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Caja abierta</div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" style="display:flex; justify-content:center; padding:56px;">
      <v-progress-circular indeterminate color="primary" size="36" />
    </div>

    <!-- Empty -->
    <div v-else-if="!sucursales.length" class="ide-ia-card" style="text-align:center; padding:56px; color:var(--text-disabled);">
      <div style="font-size:36px; margin-bottom:12px;">🏢</div>
      <div style="font-size:14px; font-weight:700; color:var(--text-muted); margin-bottom:6px;">Sin sucursales</div>
      <div style="font-size:12px;">Crea tu primera sucursal para empezar a gestionar pedidos e inventario</div>
      <button class="btn-add" @click="abrirForm(null)" style="margin:16px auto 0;">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        Nueva sucursal
      </button>
    </div>

    <!-- Grid de sucursales -->
    <div v-else style="display:grid; grid-template-columns:repeat(auto-fill, minmax(320px, 1fr)); gap:12px;">
      <div v-for="s in sucursales" :key="s.id" class="ide-ia-card" style="padding:16px; display:flex; flex-direction:column; gap:12px; cursor:pointer; transition:0.2s; border:2px solid transparent;" :style="{ borderColor: $store.getters.sucursalId === s.id ? '#818cf8' : 'transparent', background: $store.getters.sucursalId === s.id ? 'var(--bg-alt)' : 'var(--bg-card)' }" @click="gestionarSucursal(s)">
        <!-- Header card -->
        <div style="display:flex; align-items:flex-start; justify-content:space-between;">
          <div style="flex:1;">
            <div style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ s.nombre }}</div>
            <div style="font-size:11px; color:var(--text-faint); margin-top:2px;">{{ s.codigo }}</div>
          </div>
          <span :style="{ background: s.activo ? '#22c55e33' : '#ef444433', color: s.activo ? '#22c55e' : '#ef4444', padding: '2px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '600' }">
            {{ s.activo ? 'Activa' : 'Inactiva' }}
          </span>
        </div>

        <!-- Info -->
        <div style="font-size:12px; color:var(--text-muted); line-height:1.6;">
          <div v-if="s.direccion">📍 {{ s.direccion }}</div>
          <div v-if="s.telefono">📞 {{ s.telefono }}</div>
        </div>

        <!-- Stats -->
        <div style="display:grid; grid-template-columns:1fr 1fr; gap:8px; padding-top:8px; border-top:1px solid var(--border-card);">
          <div style="text-align:center; font-size:11px;">
            <div style="font-weight:700; color:var(--text-heading);">—</div>
            <div style="color:var(--text-faint); margin-top:2px;">Pedidos</div>
          </div>
          <div style="text-align:center; font-size:11px;">
            <div style="font-weight:700; color:var(--text-heading);">—</div>
            <div style="color:var(--text-faint); margin-top:2px;">Caja</div>
          </div>
        </div>

        <!-- Acciones -->
        <div style="display:flex; gap:8px; margin-top:auto;">
          <button @click.stop="editarSucursal(s)" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; font-size:12px; font-weight:600; cursor:pointer; font-family:inherit; transition:0.2s;" @mouseover="$event.target.style.background='#6366f1'" @mouseout="$event.target.style.background='#818cf8'">
            Editar
          </button>
          <button @click.stop="eliminarSucursal(s)" style="background:none; border:1px solid #ef4444; color:#ef4444; border-radius:6px; padding:8px 12px; cursor:pointer; font-size:12px; font-family:inherit; transition:0.2s;" @mouseover="$event.target.style.background='#ef444411'" @mouseout="$event.target.style.background='transparent'">
            🗑️
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Crear/Editar sucursal -->
    <div v-if="dialogForm" class="cat-overlay" @click.self="dialogForm = false">
      <div class="cat-modal" style="max-width:500px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ editandoSucursal ? 'Editar sucursal' : 'Nueva sucursal' }}</span>
          <button @click="dialogForm = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div style="overflow-y:auto; padding:18px 22px; max-height:60vh;">
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Nombre *</label>
            <input v-model="form.nombre" class="ide-input" placeholder="Ej: Sucursal La Paz" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Código *</label>
            <input v-model="form.codigo" class="ide-input" placeholder="Ej: LPZ" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Dirección</label>
            <input v-model="form.direccion" class="ide-input" placeholder="Calle y número" />
          </div>
          <div class="ide-field" style="margin-bottom:12px;">
            <label>Teléfono</label>
            <input v-model="form.telefono" class="ide-input" placeholder="+591..." />
          </div>
          <div style="display:flex; gap:8px; align-items:center;">
            <input type="checkbox" v-model="form.activo" style="width:16px; height:16px;" />
            <label style="font-size:12px; color:var(--text-muted); margin:0;">Sucursal activa</label>
          </div>
        </div>

        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogForm = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cancelar
          </button>
          <button @click="guardarSucursal" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sucursales',
  data() {
    return {
      sucursales: [],
      loading: false,
      dialogForm: false,
      editandoSucursal: null,
      form: { nombre: '', codigo: '', direccion: '', telefono: '', activo: true },
    }
  },
  computed: {
    clienteId() {
      return this.$store.getters.clienteId || this.$storage.get('user')?.clienteId || null
    },
    activas() {
      return this.sucursales.filter(s => s.activo).length
    },
    cajaAbierta() {
      return 0 // Pendiente: contar cajas abiertas
    },
  },
  mounted() {
    this.cargar()
  },
  methods: {
    async cargar() {
      this.loading = true
      try {
        this.sucursales = await this.$service.list('sucursales') || []
      } catch (err) {
        this.$message.error('Error al cargar sucursales')
      } finally {
        this.loading = false
      }
    },
    abrirForm() {
      this.editandoSucursal = null
      this.form = { nombre: '', codigo: '', direccion: '', telefono: '', activo: true }
      this.dialogForm = true
    },
    editarSucursal(s) {
      this.editandoSucursal = s
      this.form = JSON.parse(JSON.stringify(s))
      this.dialogForm = true
    },
    async guardarSucursal() {
      if (!this.form.nombre || !this.form.codigo) {
        this.$message.warning('Nombre y código son requeridos')
        return
      }
      try {
        if (this.editandoSucursal) {
          await this.$service.put(`sucursales/${this.editandoSucursal.id}`, this.form)
          this.$message.success('Sucursal actualizada')
        } else {
          await this.$service.post('sucursales', this.form)
          this.$message.success('Sucursal creada')
        }
        this.dialogForm = false
        this.cargar()
      } catch (err) {
        this.$message.error(err.message || 'Error al guardar')
      }
    },
    gestionarSucursal(s) {
      this.$store.commit('setSucursalId', s.id)
      this.$store.commit('setSucursalInfo', s)
      this.$router.push({ name: 'sucursal-detalle', params: { id: s.id } })
    },
    async eliminarSucursal(s) {
      if (!confirm(`¿Eliminar sucursal "${s.nombre}"?`)) return
      try {
        await this.$service.delete(`sucursales/${s.id}`)
        this.$message.success('Sucursal eliminada')
        this.cargar()
      } catch (err) {
        this.$message.error('Error al eliminar')
      }
    },
  },
}
</script>
